import store from "../store/store";
import moment from "moment";
import { setBetFairConnected, setDreamConnected, setSportsRadarWSConnected, updateBookMakerMarkets, updateEventMatchOddsWs, updateExchEventOddsWs, updateFancyMarkets, updatePremiumOddsfromWS, updateSBEventOddsWs } from "../store/exchangeSports/exchangeSportsReducer";
import { Frame, Stomp } from "@stomp/stompjs";
import SockJS from "sockjs-client";

let oddsStompClient: any = null;
let dreamOddsStompClient: any = null;
let sportRadarClient: any = null;
let wsSubscriptions: any = {};
let wsSpSubscriptions: any = {};
let wsSecMarketSubscritions: any = {};
let refreshBetFairInterval: NodeJS.Timeout | undefined;
let refreshSportsRadarInterval: NodeJS.Timeout | undefined;
let refreshDreamInterval: NodeJS.Timeout | undefined;
let notificationWSClient: WebSocket | null = null;
let wsNotificationSubscription: any = null;
let refreshNotificationInterval: NodeJS.Timeout | undefined;
export type WebSocketEvent = {
  type: string;
  botId?: string;
  text?: string;
  link?: string;
};

let notificationCallback: ((event: WebSocketEvent) => void) | null = null;
let walletUpdateCallback: (() => void) | null = null;
let userBotId: string | undefined = undefined;

const isWalletUpdateType = (type?: string) =>
  type?.toUpperCase() === "WALLET_UPDATE";

// Store the last base URLs for visibility-based reconnection
let lastBaseUrlsPayload: any = null;
type NotificationWSConfig = {
  baseUrl: string;
  onNotificationReceived?: (event: WebSocketEvent) => void;
  botId?: string;
  onWalletUpdate?: () => void;
};
let lastNotificationWSConfig: NotificationWSConfig | null = null;
let visibilityListenerInitialized = false;

// Check WS connection.
export const isConnected = () => oddsStompClient && oddsStompClient.connected;
export const isDreamWsConnected = () =>
  dreamOddsStompClient && dreamOddsStompClient.connected;
export const isSportRadarConnected = () =>
  sportRadarClient && sportRadarClient.connected;
export const isNotificationWSConnected = () => 
  notificationWSClient && notificationWSClient.readyState === WebSocket.OPEN;

export const connectToBFWS = (baseUrl: string) => {
  if ((!oddsStompClient) && baseUrl) {
    try {
      const bfSocket = new SockJS(baseUrl); // Create SockJS instance
      oddsStompClient = Stomp.over(bfSocket); // Create STOMP client

      // Enable debugging for STOMP (only during development/debugging phase)
      oddsStompClient.debug = () => {};

      // Configure heartbeats
      oddsStompClient.heartbeat.outgoing = 10000; // Send heartbeat every 10 seconds
      // Attempt to connect
      oddsStompClient.connect(
        {}, // Add authentication headers if required
        (frame: Frame) => {
          console.log('BF Connected successfully:', frame, ' at ', moment.now());
          store.dispatch(setBetFairConnected(true));

          // Clear the reconnection interval if already connected
          clearInterval(refreshBetFairInterval);
          refreshBetFairInterval = undefined;

        },
        (error: any) => {
          console.error('WebSocket connection error:', error, ' at ', moment.now());
          store.dispatch(setBetFairConnected(false));
          disConnectToBFWS(); // Ensure the client is disconnected
          startBFRetryInterval(baseUrl);
        }
      );
      oddsStompClient.onWebSocketClose = (event: any) => {
        console.log("WebSocket closed", event);
        store.dispatch(setBetFairConnected(false));
          disConnectToBFWS(); // Cleanup
          startBFRetryInterval(baseUrl);
      };
    } catch (e) {
      console.error('Unexpected error during WebSocket setup:', e);
    }
  } else {
    console.log('WebSocket client is already initialized or baseUrl is missing.');
  }
};

const startBFRetryInterval = (baseUrl: string) => {
  if (!refreshBetFairInterval) {
    refreshBetFairInterval = setInterval(() => {
      // console.log('Retrying BF WebSocket connection...');
      connectToBFWS(baseUrl);
    }, 30000);
  }
};

const startDreamRetryInterval = (baseUrl: string) => {
  if (!refreshDreamInterval) {
    refreshDreamInterval = setInterval(() => {
      // console.log('Retrying Dream WebSocket connection...');
      connectToDreamWS(baseUrl);
    }, 30000);
  }
};

const startSRRetryInterval = (baseUrl: string) => {
  if (!refreshSportsRadarInterval) {
    refreshSportsRadarInterval = setInterval(() => {
      // console.log('Retrying SR WebSocket connection...');
      connectToSRWS(baseUrl);
    }, 30000);
  }
};


export const disConnectToBFWS = () => {
  if (oddsStompClient) {
    for (const wsEvent of Object.keys(wsSubscriptions)) {
      wsSubscriptions[wsEvent].unsubscribe();
      console.log('bf unsubscribed ' + wsEvent);
      delete wsSubscriptions[wsEvent];
    }
    wsSubscriptions = {};
    if (oddsStompClient.connected) {
      oddsStompClient.disconnect();
    }
    oddsStompClient = null;
  }
  store.dispatch(setBetFairConnected(false));
  if (refreshBetFairInterval) {
    clearInterval(refreshBetFairInterval);
    refreshBetFairInterval = undefined;
  }
};

export const connectToDreamWS = (baseUrl: string) => {
  if ((!dreamOddsStompClient) && baseUrl) {
    try {
      const dreamSocket = new SockJS(baseUrl); // Create SockJS instance
      dreamOddsStompClient = Stomp.over(dreamSocket);
      dreamOddsStompClient.debug = () => {};

      dreamOddsStompClient.heartbeat.outgoing = 10000; // Send heartbeat every 10 seconds

      dreamOddsStompClient.connect(
        {}, // Add headers if needed
        (frame: Frame) => {
          console.log('Connected successfully:', frame, ' at ', moment.now());
          store.dispatch(setDreamConnected(true));
          clearInterval(refreshDreamInterval);
          refreshDreamInterval = undefined;
        },
        (error: any) => {
          console.error('Connection error:', error, ' at ', moment.now());
          store.dispatch(setDreamConnected(false));
          disConnectToDreamWS(); // Disconnect the client
          startDreamRetryInterval(baseUrl);
        }
      );
      dreamOddsStompClient.onWebSocketClose = (event: any) => {
        console.log("WebSocket closed", event);
        store.dispatch(setDreamConnected(false));
          disConnectToDreamWS(); // Cleanup
          startDreamRetryInterval(baseUrl);
      };
    } catch (e) {
      console.error('Unexpected error during WebSocket setup:', e);
    }
  } else {
    console.log('WebSocket client is already initialized or baseUrl is missing.');
  }
};


export const disConnectToDreamWS = () => {
  if (dreamOddsStompClient) {
    for (const wsEvent of Object.keys(wsSecMarketSubscritions)) {
      wsSecMarketSubscritions[wsEvent].unsubscribe();
      console.log('dream unsubscribed ' + wsEvent);
      delete wsSecMarketSubscritions[wsEvent];
    }

    wsSecMarketSubscritions = {};
    if (dreamOddsStompClient.connected) {
      dreamOddsStompClient.disconnect();
    }
    dreamOddsStompClient = null;
  }
  store.dispatch(setDreamConnected(false));
  if (refreshDreamInterval) {
    clearInterval(refreshDreamInterval);
    refreshDreamInterval = undefined;
  }
};

export const connectToSRWS = (baseUrl: string) => {
  if ((!sportRadarClient) && baseUrl) {
    try {
      // console.log("sr connection entered");
      const srSocket = new SockJS(baseUrl); // Create SockJS instance
      sportRadarClient = Stomp.over(srSocket); // Create STOMP client
      sportRadarClient.debug = () => {};
      // Configure heartbeats
      sportRadarClient.heartbeat.outgoing = 10000; // Send heartbeat every 10 seconds
      // Attempt to connect
      sportRadarClient.connect(
        {}, // Add authentication headers if required
        (frame: Frame) => {
          console.log('SR Connected successfully:', frame, ' at ', moment.now());
          store.dispatch(setSportsRadarWSConnected(true));

          // Clear the reconnection interval if already connected
          clearInterval(refreshSportsRadarInterval);
          refreshSportsRadarInterval = undefined;
        },
        (error: any) => {
          console.error('WebSocket connection error:', error, ' at ', moment.now());
          store.dispatch(setSportsRadarWSConnected(false));

          disConnectToSRWS(); // Ensure the client is disconnected
          startSRRetryInterval(baseUrl);
        }
      );
      sportRadarClient.onWebSocketClose = (event: any) => {
        store.dispatch(setSportsRadarWSConnected(false));
        console.log("WebSocket closed", event);
          disConnectToSRWS();
          startSRRetryInterval(baseUrl);
      };
    } catch (e) {
      console.error('Unexpected error during WebSocket setup:', e);
    }
  } else {
    console.log('SportsRadar WebSocket client already initialized or baseUrl is missing.');
  }
};


export const disConnectToSRWS = () => {
  if (sportRadarClient) {
    for (const wsEvent of Object.keys(wsSpSubscriptions)) {
      wsSpSubscriptions[wsEvent].unsubscribe();
      console.log('sr unsubscribed ' + wsEvent);
      delete wsSpSubscriptions[wsEvent];
    }

    wsSpSubscriptions = {};
    if (sportRadarClient.connected) {
      sportRadarClient.disconnect();
    }
    sportRadarClient = null;
  }
  store.dispatch(setSportsRadarWSConnected(false));
  if (refreshSportsRadarInterval) {
    clearInterval(refreshSportsRadarInterval);
    refreshSportsRadarInterval = undefined;
  }
};

// Visibility change handler for reconnection
const handleVisibilityChange = () => {
  const isVisible = document.visibilityState === 'visible';

  if (!isVisible) {
    return;
  }

  console.log('Page became visible, checking WebSocket connections...');

  if (lastBaseUrlsPayload) {
    checkStompClientSubscriptions(lastBaseUrlsPayload);
  }

  checkNotificationWSConnection();
};

// Initialize visibility listener (called once)
const initVisibilityListener = () => {
  if (!visibilityListenerInitialized) {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleVisibilityChange);
    visibilityListenerInitialized = true;
    console.log('Visibility listener initialized for WebSocket reconnection');
  }
};

//connecting to websocket

export const connectToWS = (baseUrlsPayload: any) => {
  // Store the base URLs for visibility-based reconnection
  lastBaseUrlsPayload = baseUrlsPayload;
  
  // Initialize visibility listener for reconnection
  initVisibilityListener();
  
  connectToBFWS(baseUrlsPayload?.matchOddsBaseUrl);
  connectToDreamWS(baseUrlsPayload?.bookMakerAndFancyBaseUrl);
  connectToSRWS(baseUrlsPayload?.premiumBaseUrl);
};

export const subscribeSportRadarEventOdds = (
  url: string,
  sportKey: string,
  eventId: string
) => {
  const topicUrl = `${url}/${eventId}`;
  if (sportRadarClient !== null && sportRadarClient.connected) {
    if (wsSpSubscriptions[`sp-${eventId}`] === undefined) {
      wsSpSubscriptions[`sp-${eventId}`] = sportRadarClient.subscribe(
        topicUrl,
        function (message: any) {
          const msgObj = JSON.parse(message.body);
          msgObj["current_eventId"] = eventId;
          if (sportKey && sportKey !== "") {
            msgObj["sport_key"] = sportKey;
            store.dispatch(updateSBEventOddsWs(msgObj));
          } else {
            store.dispatch(updatePremiumOddsfromWS(msgObj));
          }
        }
      );
    }
  } 
  // else {
  //   setTimeout(() => subscribeSportRadarEventOdds(url, eventId), 1000);
  // }
};

export const subscribeForMatchOdds = (
  url: string,
  sportKey: string,
  eventId: string,
  marketId?: string,
) => {
  if (oddsStompClient !== null && oddsStompClient.connected) {
    if (
      wsSubscriptions[`ws-${eventId}-${marketId}`] === undefined
    ) {
      wsSubscriptions[`ws-${eventId}-${marketId}`] =
        oddsStompClient.subscribe(
          `${url}/${eventId}/${marketId}`,
          function (message: any) {
            const msgObj = JSON.parse(message.body);
            msgObj["current_eventId"] = eventId;
            if (sportKey && sportKey !== "") {
              msgObj["sport_key"] = sportKey;
              store.dispatch(updateExchEventOddsWs(msgObj));
            } else if (eventId) {
              store.dispatch(updateEventMatchOddsWs(msgObj));
            }
          }
        );
    }
  }
  //  else {
  //   setTimeout(() => subscribeForMatchOdds(url, eventId, marketId), 1000);
  // }
};

export const subscribeWsForBookmakerMarkets = (
  url: string,
  eventId: string,
  marketId: string
) => {
  let bmUrl = url.includes("tommy") ? `${url}/${eventId}/${marketId}` : `${url}/${eventId}`;
  let key = url.includes("tommy") ? `bm-${eventId}/${marketId}` : `bm-${eventId}`;
  if (dreamOddsStompClient !== null && dreamOddsStompClient.connected) {
    if (wsSecMarketSubscritions[key] === undefined) {
      wsSecMarketSubscritions[key] =
        dreamOddsStompClient.subscribe(
          bmUrl,
          function (message: any) {
            const msgObj = JSON.parse(message.body);
            msgObj["current_eventId"] = eventId;
            store.dispatch(updateBookMakerMarkets(msgObj));
          }
        );
    }
  } 
  // else {
  //   setTimeout(() => subscribeWsForBookmakerMarkets(url, eventId, marketId), 1000);
  // }
};

export const subscribeWsForFancyMarkets = (url: string, eventId: string) => {
  if (dreamOddsStompClient !== null && dreamOddsStompClient.connected) {
    if (wsSecMarketSubscritions["fancy-" + eventId] === undefined) {
      wsSecMarketSubscritions["fancy-" + eventId] =
        dreamOddsStompClient.subscribe(
          `${url}/${eventId}`,
          function (message: any) {
            const msgObj = JSON.parse(message.body);
            msgObj["current_eventId"] = eventId;
            store.dispatch(updateFancyMarkets(msgObj));
          }
        );
    }
  } 
  // else {
  //   setTimeout(() => subscribeWsForFancyMarkets(url, eventId), 1000);
  // }
};


export const checkStompClientSubscriptions = (baseUrlsPayload: any) => {
  if (!store.getState().exchangeSports.betFairWSConnected || oddsStompClient == null) {
    // console.log('BetFair client is null or not connected', baseUrlsPayload?.matchOddsBaseUrl);
    connectToBFWS(baseUrlsPayload?.matchOddsBaseUrl);
  }
  if (!store.getState().exchangeSports.dreamWSConnected || dreamOddsStompClient == null) {
    // console.log('Dream client is null or not connected', baseUrlsPayload?.bookMakerAndFancyBaseUrl);
    connectToDreamWS(baseUrlsPayload?.bookMakerAndFancyBaseUrl);
  }
  if (!store.getState().exchangeSports.sportsRadarWSConnected || sportRadarClient == null) {
    // console.log('SR client is null or not connected', baseUrlsPayload?.premiumBaseUrl);
    connectToSRWS(baseUrlsPayload?.premiumBaseUrl);
  }
};

export const checkNotificationWSConnection = () => {
  if (!lastNotificationWSConfig) {
    return;
  }

  if (isNotificationWSConnected()) {
    return;
  }

  const { baseUrl, onNotificationReceived, botId, onWalletUpdate } = lastNotificationWSConfig;
  console.log('Notification WS is null or not connected, reconnecting...', baseUrl);

  if (
    notificationWSClient &&
    notificationWSClient.readyState !== WebSocket.CONNECTING
  ) {
    try {
      notificationWSClient.close();
    } catch (e) {
      console.log('Error closing stale notification WS client', e);
    }
    notificationWSClient = null;
  }

  connectToNotificationWS(baseUrl, onNotificationReceived, botId, onWalletUpdate);
};

// Disconnects odds/event STOMP subscriptions only. Notification WS stays open until logout.
export const disconnectToWS = () => {
  unsubscribeAllWsforEvents();
  lastBaseUrlsPayload = null;
};

// Notification WebSocket functions
// Using native WebSocket since backend uses direct WebSocket handler at /api/v1/ws/notification
export const connectToNotificationWS = (
  baseUrl: string,
  onNotificationReceived?: (event: WebSocketEvent) => void,
  botId?: string,
  onWalletUpdate?: () => void
) => {
  if (onNotificationReceived) {
    notificationCallback = onNotificationReceived;
  }
  if (onWalletUpdate) {
    walletUpdateCallback = onWalletUpdate;
  }

  if (botId) {
    userBotId = botId;
  }

  if (baseUrl) {
    lastNotificationWSConfig = {
      baseUrl,
      onNotificationReceived,
      botId,
      onWalletUpdate,
    };
    initVisibilityListener();
  }

  const canConnect =
    !notificationWSClient ||
    notificationWSClient.readyState === WebSocket.CLOSED ||
    notificationWSClient.readyState === WebSocket.CLOSING;

  if (canConnect && baseUrl) {
    try {
      const userKey = sessionStorage.getItem("userKey");
      const token = sessionStorage.getItem("token") || localStorage.getItem("token") || "";

      const wsUrl = baseUrl.replace(/^https?:\/\//, (match) =>
        match === "https://" ? "wss://" : "ws://"
      );

      const urlWithAuth = `${wsUrl}?userKey=${encodeURIComponent(userKey || "")}&token=${encodeURIComponent(token)}`;

      notificationWSClient = new WebSocket(urlWithAuth);

      notificationWSClient.onopen = () => {
        console.log("Notification WS Connected successfully at ", moment.now());

        if (userKey && notificationWSClient) {
          const subscribeMessage = JSON.stringify({
            type: "subscribe",
            topic: `/user/${userKey}/notifications`,
            userKey: userKey,
          });
          notificationWSClient.send(subscribeMessage);
          console.log("Sent subscription message for topic:", `/user/${userKey}/notifications`);
        }

        const heartbeatInterval = setInterval(() => {
          if (notificationWSClient && notificationWSClient.readyState === WebSocket.OPEN) {
            notificationWSClient.send("");
          } else {
            clearInterval(heartbeatInterval);
          }
        }, 10000);

        clearInterval(refreshNotificationInterval);
        refreshNotificationInterval = undefined;

        if (walletUpdateCallback) {
          walletUpdateCallback();
        }
      };

      notificationWSClient.onmessage = (event: MessageEvent) => {
        if (!event.data) {
          return;
        }

        try {
          const message = JSON.parse(event.data) as WebSocketEvent;

          if (message.type === "subscribed") {
            return;
          }

          if (message.botId && userBotId) {
            if (message.botId !== userBotId) {
              return;
            }
          } else if (message.botId && !userBotId) {
            return;
          }

          if (isWalletUpdateType(message.type)) {
            if (walletUpdateCallback) {
              walletUpdateCallback();
            }
            return;
          }

          if (notificationCallback) {
            notificationCallback(message);
          }
        } catch (e) {
          console.error("Error parsing notification message:", e);
        }
      };

      notificationWSClient.onerror = (error: Event) => {
        console.error("Notification WebSocket connection error:", error, " at ", moment.now());
        disConnectToNotificationWS(false);
        startNotificationRetryInterval(baseUrl, onNotificationReceived, botId, onWalletUpdate);
      };

      notificationWSClient.onclose = (event: CloseEvent) => {
        console.log("Notification WebSocket closed", event.code, event.reason, " at ", moment.now());
        notificationWSClient = null;
        disConnectToNotificationWS(false);
        if (event.code !== 1000) {
          startNotificationRetryInterval(baseUrl, onNotificationReceived, botId, onWalletUpdate);
        }
      };
    } catch (e) {
      console.error("Unexpected error during Notification WebSocket setup:", e);
    }
  } else {
    console.log("Notification WebSocket client is already initialized or baseUrl is missing.");
  }
};

const startNotificationRetryInterval = (
  baseUrl: string,
  onNotificationReceived?: (event: WebSocketEvent) => void,
  botId?: string,
  onWalletUpdate?: () => void
) => {
  if (!refreshNotificationInterval) {
    refreshNotificationInterval = setInterval(() => {
      console.log("Retrying Notification WebSocket connection...");
      connectToNotificationWS(baseUrl, onNotificationReceived, botId, onWalletUpdate);
    }, 30000);
  }
};

export const disConnectToNotificationWS = (clearStoredConfig = true) => {
  if (notificationWSClient) {
    if (notificationWSClient.readyState === WebSocket.OPEN || notificationWSClient.readyState === WebSocket.CONNECTING) {
      notificationWSClient.close(1000, "Client disconnecting");
    }
    notificationWSClient = null;
  }

  if (refreshNotificationInterval) {
    clearInterval(refreshNotificationInterval);
    refreshNotificationInterval = undefined;
  }

  notificationCallback = null;
  walletUpdateCallback = null;
  userBotId = undefined;

  if (clearStoredConfig) {
    lastNotificationWSConfig = null;
  }
};

export const unsubscribeAllWsforEvents = () => {
  if (store.getState().exchangeSports.betFairWSConnected) {
    for (const wsEvent of Object.keys(wsSubscriptions)) {
      try {
        wsSubscriptions[wsEvent].unsubscribe();
        console.log('unsubscribed ' + wsEvent);
      } catch (e) {
        console.log('bf unsubscribe failed', wsEvent);
      }
      delete wsSubscriptions[wsEvent];
    }
    wsSubscriptions = {};
  }

  if (store.getState().exchangeSports.dreamWSConnected) {
    for (const wsEvent of Object.keys(wsSecMarketSubscritions)) {
      try {
        wsSecMarketSubscritions[wsEvent].unsubscribe();
        console.log('dream unsubscribed ' + wsEvent);
      } catch (e) {
        console.log('dream unsubscribe failed', wsEvent);
      }
      delete wsSecMarketSubscritions[wsEvent];
    }
    wsSecMarketSubscritions = {};
  }

  if (store.getState().exchangeSports.sportsRadarWSConnected) {
    for (const wsEvent of Object.keys(wsSpSubscriptions)) {
      try {
        wsSpSubscriptions[wsEvent].unsubscribe();
        console.log('sr unsubscribed ' + wsEvent);
      } catch (e) {
        console.log('sr unsubscribe faled' + wsEvent);
      }
      delete wsSpSubscriptions[wsEvent];
    }
    wsSpSubscriptions = {};
  }
};
